import { Checkbox } from "@components";
import { useEffect, useState } from "react";
import VariableValueForm from "../types/VariableValueForm";

import styles from "@styles/pages/cdp/filters.module.scss";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

const input_configs = {
  type: "currency",
  prefix: "R$ ",
  suffix: "",
  precision: 2,
  min: 0,
};

export const OrderValueForm = ({ data, variable, onChange }) => {
  const [collapsed, setCollapsed] = useState(false);

  const freshData = {
    name: variable.label,
    type: "c.total_orders",
    operand: "bt",
    values: [data?.values[0] || null, data?.values[1] || null],
    active: data?.active || false,
  };

  useEffect(() => {
    if (freshData.active) setCollapsed(true);
  }, [freshData.active]);

  return (
    <li className={css({ filter: true, collapsed })} key={variable.label}>
      <div
        className={styles.header}
        onClick={() =>
          !freshData.active && onChange({ ...freshData, active: true })
        }
      >
        <div className="d-flex align-center">
          <Checkbox
            design="two"
            label={variable.label}
            checked={freshData.active}
            onChange={(value) => onChange({ ...freshData, active: value })}
          />
          {freshData.active && <div className={styles.dot} />}
        </div>
        <div className="d-flex align-center">
          <div
            className={styles.collapse}
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? (
              <i className="fas fa-minus" />
            ) : (
              <i className="fas fa-plus" />
            )}
          </div>
        </div>
      </div>

      {collapsed && (
        <div className={styles.content}>
          <VariableValueForm
            data={freshData}
            onChange={(newData) => {
              onChange({ ...data, ...newData });
            }}
            input_configs={input_configs}
          />
        </div>
      )}
    </li>
  );
};
